import BaseModel from "./base/baseModel";

export default class JustificativaControleReclamacaoModel extends BaseModel {
    id: number;
    descricao: string = null;
}
